<div fxLayout="column" fxLayoutGap="12px">
  <ng-content></ng-content>
</div>
